import React, { useState, useEffect } from "react";
import { Row, Col, Grid, Layout, Typography, Button, Card, Table } from "antd";
import MapComponent from "./Map";
import TabellaRiassuntiva from "./TabellaDati";
import LineModal from "./modals/LineModals";
import {
  deleteManovra,
  updateManovra,
  deleteAllManovre,
  getManovre,
  addManovra,
  createConflitti,
} from "../../apis";
import '../../styles/pages/landing.css';
const { Title, Text } = Typography;
const { Sider, Content } = Layout;

const Semafix = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [flussi, setFlussi] = useState([]);
  const [flussiModal, setFlussiModal] = useState({
    open: false,
    currentLang: null,
  });
  const [resizeTrigger, setResizeTrigger] = useState(0);
  const [optimizedData, setOptimizedData] = useState(null);
  const [hoveredFlusso, setHoveredFlusso] = useState(null);
  const [updatePolylineColor, setUpdatePolylineColor] = useState(
    () => () => {}
  );
  const [conflitti, setConflitti] = useState([]);

  const loadManovre = async () => {
    try {
      const data = await getManovre();

      if (!data || data.length === 0) {
        return;
      }

      const flussiFromDB = data
        ?.sort((a, b) => a.id - b.id)
        ?.map((item) => ({
          id: item.id,
          latlngs: [...item?.latlngs], // make sure it's not a self-referencing object
          data: {
            title: item.title,
            inputType: item.inputType,
            color: item.color,
            capSatResult: item.capSatResult,
            verdeMin: item.verdeMin,
            flussi: item?.flussi ? [...item.flussi] : [], // clone to avoid references
            isManual: item.manual,
            saved: true,
          },
        }));
      if (!flussiFromDB || flussiFromDB.length === 0) {
        setFlussi(flussiFromDB);
      }
    } catch (err) {
      console.error("Errore nel caricamento delle manovre:", err);
    }
  };

  useEffect(() => {
    loadManovre();
  }, []);

  const handleSelect = (flusso) => {
    setFlussiModal({
      open: true,
      currentLang: flusso.latlngs,
      isNew: false,
    });
  };

  // Prevent infinite loop: only save conflitti if they actually changed and workflow_id exists
  useEffect(() => {
    let cancelled = false;
    const workflow_id = localStorage.getItem("workflow_id");
    if (workflow_id && conflitti.length !== 0) {
      const saveConflitti = async () => {
        try {
          await createConflitti(conflitti, workflow_id);
        } catch (e) {
          // Optionally handle error
        }
      };
      saveConflitti();
    }
    return () => {
      cancelled = true;
    };
  }, [conflitti]);

  const handleDeleteAll = async () => {
    try {
      await deleteAllManovre();

      // Clear all polylines and decorators from the map
      const event = new CustomEvent("delete-all-manovre");
      window.dispatchEvent(event);

      // Then clear the state
      setFlussi([]);
      setConflitti([]);
    } catch (err) {
      console.error(err);
    }
  };

  // Utility: Safe JSON.stringify to avoid circular reference errors
  function safeStringify(obj) {
    const seen = new WeakSet();
    return JSON.stringify(obj, function (key, value) {
      if (typeof value === "object" && value !== null) {
        if (seen.has(value)) return "[Circular]";
        seen.add(value);
      }
      return value;
    });
  }

  const handleModalOk = async (data) => {
    const currentLatlngs = flussiModal.currentLang;

    const index = flussi.findIndex(
      (f) => safeStringify(f.latlngs) === safeStringify(currentLatlngs)
    );

    const defaultTitle = `Manovra ${index + 1}`;
    const newTitle = data.title?.trim() === "" ? defaultTitle : data.title;

    const updated = {
      ...flussi[index],
      data: { ...flussi[index].data, ...data, title: newTitle, saved: true },
    };
    const safeData = {
      title: updated.data.title,
      inputType: updated.data.inputType || "",
      color: updated.data.color,
      capSatResult:
        updated.data.capSatResult === "" ||
        updated.data.capSatResult === undefined
          ? null
          : Number(updated.data.capSatResult),
      verdeMin: updated.data.verdeMin ? parseInt(updated.data.verdeMin) : 0,
      flussi: updated.data.flussi || [],
      latlngs: updated.latlngs,
      inputSource: updated.data.inputSource || "manual",
      isManual: updated.data.isManual,
    };

    try {
      if (!flussi[index].data?.saved) {
        var workflow_id = localStorage.getItem("workflow_id");
        const response = await addManovra({ ...safeData, workflow_id });
        updated.id = response.id;
        if (response.workflow_id)
          localStorage.setItem("workflow_id", response.workflow_id);
      } else {
        await updateManovra(flussi[index].id, safeData);
      }

      updated.data.saved = true;
      setFlussi(flussi.map((f, i) => (i === index ? updated : f)));

      if (window.updatePolylineColor) {
        window.updatePolylineColor(currentLatlngs, data.color);
      }

      setFlussiModal({ open: false, currentLang: null });
    } catch (err) {
      console.error("Errore durante il salvataggio/aggiornamento:", err);
      alert("Errore durante il salvataggio della manovra.");
    }
  };

  const handleModalCancel = () => {
    const currentLatlngs = flussiModal.currentLang;

    const manovra = flussi.find(
      (f) => safeStringify(f.latlngs) === safeStringify(currentLatlngs)
    );

    if (flussiModal.isNew && manovra && !manovra.data?.saved) {
      setFlussi((prev) =>
        prev.filter(
          (f) => safeStringify(f.latlngs) !== safeStringify(currentLatlngs)
        )
      );

      const event = new CustomEvent("delete-manovra", {
        detail: currentLatlngs,
      });
      window.dispatchEvent(event);
    }

    setFlussiModal({ open: false, currentLang: null });
  };

  const addFlusso = (latlngs, name) => {
    setFlussi([
      ...flussi,
      {
        id: flussi.length + 1,
        data: {
          title: name || "",
          inputType: "",
          color: "#000000",
          capSatResult: null,
          flussi: [],
          verdeMin: "",
          saved: false,
        },
        latlngs: latlngs || null,
      },
    ]);
  };

  const handleDeleteManovra = async (id) => {
    try {
      await deleteManovra(id);
      setFlussi((prev) => prev.filter((f) => f.id !== id));
      setConflitti((prev) =>
        prev.filter(([a, b]) => a !== `Manovra ${id}` && b !== `Manovra ${id}`)
      );
    } catch (err) {}
  };

  return (
    <>
      <Layout className="landing-layout">
        <Sider
          collapsible
          width={500}
          className="landing-sider"
          breakpoint="lg"
          collapsedWidth="0"
        >
          <div className="landing-sidebar-container">
            <Title level={4} className="landing-sidebar-title">
              Lista Manovre
            </Title>

            <Card size="small" className="landing-sidebar-card">
              <TabellaRiassuntiva
                flussi={flussi}
                onSelect={handleSelect}
                onOptimize={setOptimizedData}
                optimizedData={optimizedData}
                onHover={setHoveredFlusso}
                conflittiSelezionati={conflitti}
                onDelete={handleDeleteManovra}
                onDeleteAll={handleDeleteAll}
              />
            </Card>
          </div>
        </Sider>

        <Layout>
          <Content className="landing-content">
            <Row
              className="line2-semafix landing-header-row"
            >
              <h3 className="landing-header-title">Editor Intersezione</h3>
            </Row>

            <Row
              gutter={[16, 16]}
              className="landing-map-row"
            >
              <Col xs={24} className="landing-map-col">
                <MapComponent
                  addFlusso={addFlusso}
                  flussi={flussi}
                  setFlussi={setFlussi}
                  resizeTrigger={resizeTrigger}
                  hoveredFlusso={hoveredFlusso}
                  conflittiSelezionati={conflitti}
                  setConflittiSelezionati={setConflitti}
                  exposeUpdatePolylineColor={setUpdatePolylineColor}
                  flussiModal={flussiModal}
                  setFlussiModal={setFlussiModal}
                  optimizedData={optimizedData}
                />
              </Col>
            </Row>

            <LineModal
              isModalOpen={flussiModal.open}
              handleOk={handleModalOk}
              handleCancel={handleModalCancel}
              currentLang={flussiModal.currentLang}
              isNew={flussiModal.isNew}
              flussi={flussi}
              addFlusso={addFlusso}
            />
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default Semafix;
